import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import useSelectedBusiness from '../../../hooks/business/useSelectedBusiness';

export default function PaymentCompletionPage(): JSX.Element {
  const [status, setStatus] = useState<string>('loading');
  const { t } = useTranslation();
  const business = useSelectedBusiness();
  const navigate = useNavigate();

  useEffect((): void => {
    const params = new URLSearchParams(window.location.search);
    const redirectStatus: string = params.get('redirect_status')!;
    const customerId = params.get('customerId');
    const type = params.get('type');

    if (!redirectStatus) {
      navigate('/overview');
    }

    if (customerId && business && business.businessId && status === 'loading' && type === 'setup') {
      setStatus('loading');
      let attempts = 0;
      const maxAttempts = 10;
      const interval = 3000;
      const poller = setInterval(() => {
        attempts += 1;
        fetch(`/api/payment-details`)
          .then(response => {
            if (response.status === 200) {
              clearInterval(poller);
              navigate('/subscriptions/manage');
            }
          })
          .catch(err => {
            console.error('Error fetching payment details:', err);
            clearInterval(poller);
            navigate('/subscriptions/manage');
          });
        if (attempts >= maxAttempts) {
          clearInterval(poller);
          setStatus('loading');
        }
      }, interval);
    } else {
      setStatus(redirectStatus);
    }
  }, []);

  if (status === 'loading') {
    return (
      <div className="flex flex-col items-center justify-center p-8">
        <div className="h-8 w-8 animate-spin rounded-full border-b-2 border-primary-900 mb-4" />
        <h1 className="text-3xl font-extrabold text-primary mb-2">{t(`page.payment.loading`)}</h1>
        <p className="text-lg text-gray-600 font-medium text-center max-w-md">{t(`page.payment.loadingSubtitle`)}</p>
      </div>
    );
  }
  if (status === 'succeeded') {
    return (
      <div className="mx-auto my-auto flex flex-col">
        <h1 className="mx-auto text-3xl font-bold">{t(`toast.success.subscriptionPayment`)}</h1>
        <p className="mx-auto text-xl font-bold">
          {t(`toast.success.subscriptionPaymentSubtitle`)}
        </p>
      </div>
    );
  }
  if (status === 'failed') {
    return (
      <div className="mx-auto my-auto flex flex-col">
        <h1 className="mx-auto text-3xl font-bold">Er is iets misgegaan</h1>
        <p className="mx-auto text-xl font-bold">Probeer het later opnieuw!</p>
      </div>
    );
  }
  return <></>;
}
